import React from 'react'
import { FaEye, FaUserPlus } from "react-icons/fa";
import { FaRegBuilding } from "react-icons/fa";
import { FaUserSecret } from "react-icons/fa";
import { FaUsers } from "react-icons/fa6";
import { FaCogs } from "react-icons/fa";
import { FaTicketAlt } from "react-icons/fa";


export default function Summary({count}) {
  const viewTickets = () => {
    const destinationUrl = localStorage.getItem("destinationUrl");
    if (destinationUrl) {
      window.open(`${destinationUrl}a/tickets`, "_blank");
    } else {
      console.log("No destination URL found in localStorage");
    }
  };
  return (
    <div className='flex justify-center'>
      <div className='summary-card w-[500px]'>
        <div className='py-[13px] px-[20px] bg-[#f1f1f1]' style={{ borderRadius: '10px 10px 0px 0px' }}>
          <p className='text-[18px] text-[#2e496f] font-[500]' style={{ margin: '0' }}>Migration Reports</p>
        </div>
        <div className='p-[30px]'>
          <div>

            <div className='flex items-center gap-[15px]'>
              <FaUserPlus className='text-[20px] text-[#2f4a83]' />
              <p className='migrate-para w-[60px]'>GROUPS</p>
              <div className='w-[65%]'><hr className='border-dashed border-[#ddd] border-[1.2px]' /></div>
              <p className='migrate-para'>{count.groupsDestinationCount}</p>
            </div>

            <div className='flex items-center gap-[15px] mt-4'>
              <FaRegBuilding className='text-[20px] text-[#2f4a83]' />
              <p className='migrate-para w-[60px]'>ORGS</p>
              <div className='w-[65%]'><hr className='border-dashed border-[#ddd] border-[1.2px]' /></div>
              <p className='migrate-para'>{count.orgsDestinationCount}</p>
            </div>

            <div className='flex items-center gap-[15px] mt-4'>
              <FaUserSecret className='text-[20px] text-[#2f4a83]' />
              <p className='migrate-para w-[60px]'>AGENTS</p>
              <div className='w-[65%]'><hr className='border-dashed border-[#ddd] border-[1.2px]' /></div>
              <p className='migrate-para'>{count.agentsDestinationCount}</p>
            </div>
            <div className='flex items-center gap-[15px] mt-4'>
              <FaUsers className='text-[20px] text-[#2f4a83]' />
              <p className='migrate-para w-[60px]'>USERS</p>
              <div className='w-[65%]'><hr className='border-dashed border-[#ddd] border-[1.2px]' /></div>
              <p className='migrate-para'>{count.usersDestinationCount}</p>
            </div>

            <div className='flex items-center gap-[15px] mt-4'>
              <FaCogs className='text-[20px] text-[#2f4a83]' />
              <p className='migrate-para w-[60px]'>FIELDS</p>
              <div className='w-[65%]'><hr className='border-dashed border-[#ddd] border-[1.2px]' /></div>
              <p className='migrate-para'>{count.fieldsDestinationCount}</p>
            </div>

            <div className='flex items-center gap-[15px] mt-4'>
              <FaTicketAlt className='text-[20px] text-[#2f4a83]' />
              <p className='migrate-para w-[60px]'>TICKETS</p>
              <div className='w-[65%]'><hr className='border-dashed border-[#ddd] border-[1.2px]' /></div>
              <p className='migrate-para'>{count.ticketsDestinationCount}</p>
            </div>
          </div>
        </div>
        <div className='flex justify-end px-[20px] py-[10px] bg-[#fff]' style={{borderRadius:'0px 0px 10px 10px',borderTop:'1px solid #ddd'}}>
          <button className='text-[13px] text-[#fff] px-[15px] rounded-[5px] py-[4px] bg-[#193570] flex items-center gap-2 whitespace-nowrap' onClick={viewTickets}>View tickets<FaEye className='text-[16px]' /></button>
        </div>
      </div>
    </div>
  )
}
